import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { SliderSlide } from '../../../interfaces/Slider/SliderSlide';
import { updateSliderSlide } from '../../../api/Slider';
import { sharedStyles } from '../../../utils/Style';
import { Waiting } from '../../../components/Waiting/Waiting';
import { LanguageDropdown } from '../../../components/Dropdowns/LanguageDropdown';
import {
  SliderType,
  sliderTypeNameMap,
} from '../../../interfaces/Slider/SliderType';

interface UpdateSliderSlideFieldsProps {
  feURL: string;
  sliderSlide: SliderSlide;
  onUpdate: () => void;
}

export const UpdateSliderSlideFields = (
  props: UpdateSliderSlideFieldsProps,
) => {
  const [url, setUrl] = useState('');
  const [locale, setLocale] = useState<string | undefined>(undefined);
  const [type, setType] = useState<SliderType>('all');

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setUrl(props.sliderSlide.url ?? '');
    setLocale(props.sliderSlide.locale);
    setType(props.sliderSlide.type);
  }, [props.sliderSlide]);

  const handleSave = () => {
    setLoading(true);
    updateSliderSlide({
      ...props.sliderSlide,
      url: url || undefined,
      locale,
      type,
    })
      .then(() => {
        toast.success('Kaydırıcı başarıyla güncellendi');
        props.onUpdate();
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
      }}
    >
      <Waiting open={loading} />

      <FormControl size='small' fullWidth>
        <InputLabel>Cihaz Tipi</InputLabel>

        <Select
          label='Cihaz Tipi'
          value={type}
          onChange={(e) => setType(e.target.value as SliderType)}
        >
          {Object.keys(sliderTypeNameMap).map((key) => (
            <MenuItem key={key} value={key}>
              {sliderTypeNameMap[key as SliderType]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <LanguageDropdown
        label='Hedef Dil'
        allowDefault
        defaultOptionLabel='Tüm Diller'
        value={locale || null}
        onChange={(x) => setLocale(x || undefined)}
      />

      <TextField
        label='Hedef URL'
        variant='outlined'
        size='small'
        fullWidth
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        helperText={url && props.feURL ? `${props.feURL}/${url}` : undefined}
      />

      <Button
        variant='contained'
        size='small'
        onClick={handleSave}
        startIcon={<SaveIcon />}
        sx={{ ...sharedStyles.buttonText, alignSelf: 'flex-end' }}
      >
        Kaydet
      </Button>
    </Box>
  );
};
